module.exports = __webpack_public_path__ + "img/monkey_king.8ae823d9.jpg";